import { render, staticRenderFns } from "./lr-detail.vue?vue&type=template&id=728e950f&scoped=true"
import script from "./lr-detail.vue?vue&type=script&lang=ts"
export * from "./lr-detail.vue?vue&type=script&lang=ts"
import style0 from "./lr-detail.vue?vue&type=style&index=0&id=728e950f&lang=scss"
import style1 from "./lr-detail.vue?vue&type=style&index=1&id=728e950f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728e950f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('728e950f')) {
      api.createRecord('728e950f', component.options)
    } else {
      api.reload('728e950f', component.options)
    }
    module.hot.accept("./lr-detail.vue?vue&type=template&id=728e950f&scoped=true", function () {
      api.rerender('728e950f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders-dispatches/lr-detail.vue"
export default component.exports